// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { MAMode } from '../IndicatorConstants';
import { IndicatorScriptBase } from '../IndicatorScriptBase';
import { Color } from '../../../Graphics';
import { LineStyle } from '../IndicatorScriptBaseEnums';
import { InputParameterInteger } from '../InputParamaterClasses/InputParameterInteger';
import { PriceType } from '@shared/utils/History/CashItemUtils';
import { InputParameterCombobox } from '../InputParamaterClasses/InputParameterCombobox';
export class TEMA extends IndicatorScriptBase {
    constructor() {
        super();
        this.ProjectName = 'Triple EMA';
        this.Comments = 'Triple EMA';
        super.SetIndicatorLine('tema', Color.Red, 2, LineStyle.SimpleChart);
        this.SeparateWindow = false;
        this.PeriodMA = 9;
        super.InputParameter(new InputParameterInteger('PeriodMA', 'Period of EMA', 0, 1, 9999));
        this.SourcePrice = PriceType.Close;
        super.InputParameter(new InputParameterCombobox('SourcePrice', 'Sources prices for EMA', 1, [
            { Close: PriceType.Close },
            { Open: PriceType.Open },
            { High: PriceType.High },
            { Low: PriceType.Low },
            { Typical: PriceType.Typical },
            { Medium: PriceType.Medium },
            { Weighted: PriceType.Weighted }
        ]));
    }
    Init() {
        super.Init();
        super.IndicatorShortName(this.GetIndicatorShortName());
    }
    GetIndicatorShortName() {
        return 'TEMA(' + this.PeriodMA + ')';
    }
    getCustomName() {
        return 'TEMA (' + this.ProjectName + ')';
    }
    NextBar() {
        super.NextBar();
    }
    createInternalIndicators() {
        this.ema = this.Indicators.iMA(this.CurrentData, this.PeriodMA, MAMode.EMA, 0, this.SourcePrice);
        const emaAccessor = (offset) => {
            return this.ema.GetValue(offset);
        };
        this.ema1Indicator = this.Indicators.iMAExOnArray(this.CurrentData, emaAccessor, this.PeriodMA, MAMode.EMA, 0, 0);
        const ema1Accessor = (offset) => {
            return this.ema1Indicator.GetValue(offset);
        };
        this.ema2Indicator = this.Indicators.iMAExOnArray(this.CurrentData, ema1Accessor, this.PeriodMA, MAMode.EMA, 0, 0);
        super.IndicatorShortName(this.GetIndicatorShortName());
        return [this.ema, this.ema1Indicator, this.ema2Indicator];
    }
    OnQuote() {
        super.OnQuote();
        if (this.CurrentData.Count - 1 <= this.PeriodMA) {
            return;
        }
        const emaVal = this.ema.getValue();
        const ema1Val = this.ema1Indicator.GetValue();
        const ema2Val = this.ema2Indicator.GetValue();
        const temaVal = 3 * emaVal - 3 * ema1Val + ema2Val;
        super.SetValue(0, 0, temaVal);
    }
}
